<template>
  <v-card flat>
    <x-uploader
      label="项目附件"
      icon="attachment"
      :action="fileUri"
      v-model="items"
      :delete-remote="true"
      :disabled="
        (roleId !== 'DbdqbSexgAA' && !funcIds.includes('c_proj_attachment'))
        || (roleId === 'DbdqbSexgAA' && !['draft', 'returned'].includes(project.status.identifier))"
      :size="Number(50)"
      description="单个附件大小不超过 50M."
    />
  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'

  import XUploader from '@/components/global/Uploader'

  const baseURI = '/api/proj/attachment';

  export default {
    components: {XUploader},

    props: {
      project: Object
    },

    data: () => ({
      items: [],

    }),

    computed: {
      ...mapGetters(['funcIds', 'roleId']),
      fileUri() {
        const ownerId = this.project ? this.project.dbid : '';
        return `${baseURI}?ownerId=${ownerId}`;
      }
    },

    watch: {
      project(p) {
        this.axios
          .get(`${baseURI}?projectId=${p.dbid}`)
          .then(rsp => this.items = rsp.data.items)
      }
    },

    methods: {
      onEditOk(item) {
        //console.log("in Income onEditOK");
        if (item) {
          if (!this.editDbid) {
            this.items.unshift(item);
          } else {
            const editIdx = this.items.findIndex((v) => v.dbid === item.dbid);
            this.items[editIdx] = window.xutil.clone(item);
          }
          this.items = this.items.sort((a, b) => a.rank >= b.rank);
        }
      },
      onDeleOk(item) {
        if (item) {
          const deleIdx = this.items.findIndex((v) => v.dbid === item.dbid);
          this.items.splice(deleIdx, 1);
        }
      }
    }
  }
</script>
